import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MaintenanceService } from '../../services/maintenanceService';
import { ToastrService } from 'ngx-toastr';
import { ExportDataService } from '../../../shared/services/export-data.service';
import { SharedAuthService } from '../../../shared/shared.auth.service';

@Component({
    selector: 'app-enterprise-initiative-field-management',
    templateUrl: './enterprise-initiative-field-management.component.html',
    styleUrl: './enterprise-initiative-field-management.component.css',
    standalone: false
})
export class EnterpriseInitiativeFieldManagementComponent {
  @Input() fieldData: any;
  fieldDataArr: Array<any> = [];
  displayedColumnsForGeneric: Array<any> = [];
  displayedColumnsForInitiative: Array<any> = [];
  @ViewChild('modalEnableField', { static: false }) modalEnableField;
  clearFormFields: boolean = false;
  isUserAdmin: any;
  @Input() initiativeId: any;
  isSystemAdmin: boolean = false;
  isAdmin: boolean = false;
  showLoader: boolean = false;
  displayedColumnsForCalcInitiative: Array<any> = [];
  reorderRowsForGeneric: Array<any> = [];
  reorderRowsForInitiative: Array<any> = [];
  reorderRowsForCalcInitiative: Array<any> = [];
  @Input() selectedInitiative: any;
  @Output() refreshData = new EventEmitter();
  updatedType: string = '';
  editRolesOptions: Array<any> = [];
  noFieldsToEnable: boolean = false;
  categoryList: Array<any> = [];
  constructor(
    private maintenanceService: MaintenanceService,
    private toastrService: ToastrService,
    private exportService: ExportDataService,
    private sharedAuthService : SharedAuthService
  ) {
    this.isSystemAdmin = this.sharedAuthService.checkForRoleAccess('System Admin');
    this.isAdmin = this.sharedAuthService.checkForRoleAccess('Admin'); 
  }

  ngOnChanges(): void {
    this.showLoader = true;
    if (!this.updatedType) {
      this.initiliaseData();
    } else {
      this.reorderRowsForGeneric = [];
      this.reorderRowsForInitiative = [];
      this.reorderRowsForCalcInitiative = [];
    }
    if (this.initiativeId && this.editRolesOptions.length == 0 && (this.isAdmin || this.isSystemAdmin)) {
      this.getRoleDrpdwnLst();
    }
    if (Object.keys(this.fieldData).length > 0) {
      if (this.isSystemAdmin) {
        if(!this.fieldData['Generic'] && !this.fieldData['Initiative'] && !this.fieldData['Calc_initiative']) {
          this.noFieldsToEnable = false;
        }
        else if(!this.fieldData['Generic'] || !this.fieldData['Initiative'] || !this.fieldData['Calc_initiative']) {
          this.noFieldsToEnable = false;
        }
       else if ((this.fieldData['Generic'] && this.fieldData['Generic'].length < 50) || (this.fieldData['Initiative'] && this.fieldData['Initiative'].length < 50) || (this.fieldData['Calc_initiative'] && this.fieldData['Calc_initiative'].length < 10)) {
          this.noFieldsToEnable = false;
        } else {
          this.noFieldsToEnable = true;
        }
      } else if (this.isAdmin) {
        if (this.fieldData['Initiative'] && this.fieldData['Initiative'].length >= 50) {
          this.noFieldsToEnable = true;
        } else {
          this.noFieldsToEnable = false;
        }
      }
      this.setTableConfig();
      if (this.updatedType && this.fieldDataArr.length > 0) {
        this.refreshFieldArray(this.updatedType);
      } else {
        this.updatedType = '';
        this.createFieldDataArr();
      }
    }
    this.showLoader = false;
  }

  setTableConfig() {
    this.displayedColumnsForCalcInitiative = [
      { label: 'Order', key: 'currentOrder', align: 'center', width: '12%', isTableKey: true },
      { label: 'Column ID', key: 'column_id', align: 'center', width: '12%', isSystemAdminEdit: false, isAdminEdit: false, isTableKey: false },
      { label: 'Column Name', key: 'column_name', align: 'center', width: '15%', isSystemAdminEdit: true, isAdminEdit: true, isTableKey: true },
      { label: 'Description', key: 'Description', align: 'center', width: '20%', isSystemAdminEdit: true, isAdminEdit: true, isTableKey: true },
      { label: 'Visible', key: 'Visible', align: 'center', width: '12%', isSystemAdminEdit: true, isAdminEdit: true, isTableKey: false },
      { label: 'Bulk Required', key: 'Bulk_required', align: 'center', width: '15%', isSystemAdminEdit: true, isAdminEdit: false, isTableKey: true },
      { label: 'Modify UI', key: 'Modify_UI', align: 'center', width: '12%', isSystemAdminEdit: true, isAdminEdit: false, isTableKey: false },
    ];

    this.displayedColumnsForGeneric = [
      { label: 'Order', key: 'currentOrder', align: 'center', width: '7%', isTableKey: true },
      { label: 'Column ID', key: 'column_id', align: 'center', width: '16%', isSystemAdminEdit: false, isAdminEdit: false, isTableKey: true },
      { label: 'Column Name', key: 'column_name', align: 'left', width: '15%', isSystemAdminEdit: true, isAdminEdit: true, isTableKey: true },
      { label: 'Description', key: 'Description', align: 'left', width: '20%', isSystemAdminEdit: true, isAdminEdit: true, isTableKey: true },
      { label: 'Visible', key: 'Visible', align: 'center', width: '12%', isSystemAdminEdit: true, isAdminEdit: true, isTableKey: true },
      { label: 'Bulk Required', key: 'Bulk_required', align: 'center', width: '15%', isSystemAdminEdit: true, isAdminEdit: false, isTableKey: true },
      { label: 'Modify UI', key: 'Modify_UI', align: 'center', width: '12%', isSystemAdminEdit: true, isAdminEdit: false, isTableKey: false },
      { label: 'Category', key: 'category', align: 'left', width: '10%', paddingLeft: '1%', isSystemAdminEdit: true, isAdminEdit: true, isTableKey: false },
      { label: 'Sub Category', key: 'SubCategory', align: 'left', width: '10%', paddingLeft: '1%', isSystemAdminEdit: true, isAdminEdit: true, isTableKey: false },
      { label: 'Category Default State', key: 'category_default_state', align: 'center', width: '10%', paddingLeft: '0.5%', isSystemAdminEdit: true, isAdminEdit: true, isTableKey: false },
      
    ];

    this.displayedColumnsForInitiative = [
      { label: 'Order', key: 'currentOrder', align: 'center', width: '4%', paddingLeft: '0.5%', isTableKey: true },
      { label: 'Field Type', key: 'Field_Type', align: 'left', width: '7%', paddingLeft: '0.5%', isSystemAdminEdit: true, isAdminEdit: true, isTableKey: true },
      { label: 'Column ID', key: 'column_id', align: 'center', width: '6%', paddingLeft: '0.5%', isSystemAdminEdit: false, isAdminEdit: false, isTableKey: false },
      { label: 'Column Name', key: 'column_name', align: 'left', width: '10%', paddingLeft: '0.5%', isSystemAdminEdit: true, isAdminEdit: true, isTableKey: true },
      { label: 'Description', key: 'Description', align: 'left', width: '15%', paddingLeft: '0.5%', isSystemAdminEdit: true, isAdminEdit: true, isTableKey: true },
      { label: 'Input Type', key: 'input_type', align: 'left', width: '9%', paddingLeft: '0.5%', isSystemAdminEdit: true, isAdminEdit: true, isTableKey: true },
      { label: 'Visible', key: 'Visible', align: 'center', width: '5%', paddingLeft: '0.5%', isSystemAdminEdit: true, isAdminEdit: true, isTableKey: true },
      { label: 'Editable', key: 'Editable', align: 'center', width: '5%', paddingLeft: '0.5%', isSystemAdminEdit: true, isAdminEdit: true, isTableKey: true },
      { label: 'Bulk Required', key: 'Bulk_required', align: 'center', width: '9%', paddingLeft: '0.5%', isSystemAdminEdit: true, isAdminEdit: true, isTableKey: true },
      { label: 'Allowed Values', key: 'allowed_values', align: 'left', width: '14%', paddingLeft: '0.5%', isSystemAdminEdit: true, isAdminEdit: true, isTableKey: true },
      { label: 'Edit Roles', key: 'Edit_Roles', align: 'left', width: '10%', paddingLeft: '1%', isSystemAdminEdit: true, isAdminEdit: true, isTableKey: false },
      { label: 'Category', key: 'category', align: 'left', width: '10%', paddingLeft: '1%', isSystemAdminEdit: true, isAdminEdit: true, isTableKey: true },
      { label: 'Sub Category', key: 'SubCategory', align: 'left', width: '10%', paddingLeft: '1%', isSystemAdminEdit: true, isAdminEdit: true, isTableKey: false },
      { label: 'Category Default State', key: 'category_default_state', align: 'center', width: '10%', paddingLeft: '0.5%', isSystemAdminEdit: true, isAdminEdit: true, isTableKey: false },
      { label: 'Data Type', key: 'data_type', align: 'center', width: '8%', paddingLeft: '0.5%', isSystemAdminEdit: true, isAdminEdit: true, isTableKey: false },
      { label: 'Length', key: 'length', align: 'center', width: '7%', paddingLeft: '0.5%', isSystemAdminEdit: true, isAdminEdit: true, isTableKey: false },
      { label: 'Modify UI', key: 'Modify_UI', isSystemAdminEdit: true, paddingLeft: '0.5%', isAdminEdit: false, isTableKey: false },
      { label: 'View Role', key: 'View_Role', isSystemAdminEdit: false, paddingLeft: '0.5%', isAdminEdit: false, isTableKey: false },

    ];
    if (this.isAdmin || this.isSystemAdmin) {
      const actionObj = { label: 'Action', key: 'Action', align: 'center', width: '8%', isTableKey: true };
      const positionObj = { label: '', key: 'position', width: '3%', align: 'left', isTableKey: true };
      this.displayedColumnsForCalcInitiative.push(actionObj);
      this.displayedColumnsForInitiative.push(actionObj);
      this.displayedColumnsForGeneric.push(actionObj);
      this.displayedColumnsForCalcInitiative.unshift(positionObj);
      this.displayedColumnsForGeneric.unshift(positionObj);
      this.displayedColumnsForInitiative.unshift(positionObj);
    }
  }

  initiliaseData() {
    this.fieldDataArr = [];
    this.reorderRowsForGeneric = [];
    this.reorderRowsForInitiative = [];
    this.reorderRowsForCalcInitiative = [];
  }

  createFieldDataArr() {
    const keys: Array<any> = Object.keys(this.fieldData);
    this.addReorderKey('key', false);
    this.addReorderKey('Generic', true);
    this.addReorderKey('Initiative', true);
    this.addReorderKey('Calc_initiative', true);
    this.categoryList = [];
    const displayKeys = [];
    if (keys.includes('key') || keys.includes('Generic')) displayKeys.push('Generic');
    if (keys.includes('Calc_initiative')) displayKeys.push('Calc_initiative');
    if (keys.includes('Initiative')) displayKeys.push('Initiative');
    displayKeys.forEach(val => {
      let obj: any = {};
      // if (val != 'key' && val != 'Calc_initiative') {
        obj = this.getFieldObject(val);
        if(obj.tableData && obj.tableData.length > 0) {
        this.categoryList = [...this.categoryList , ...this.getCategories(obj)];
        this.fieldDataArr.push(obj);
         }
      // }
    });
  }

  refreshFieldArray(type) {
    if (type == 'Generic') this.addReorderKey('key', false);
    this.addReorderKey(type, true);
    const obj = { ...this.getFieldObject(type), isUpdated: true };
    const idx = this.fieldDataArr.findIndex(v => v.name == type);
    if (idx >= 0) this.fieldDataArr[idx] = obj;
    else if (obj.tableData?.length > 0) this.fieldDataArr.push(obj);
    this.fieldDataArr.forEach(v => { if (v.name != type) v.isUpdated = false; });
    this.categoryList = this.fieldDataArr.flatMap(v => this.getCategories(v));
    this.updatedType = '';
  }

  getFieldObject(name) {
    let displayedColumns: any;
    let tableData: Array<any> = [];

    const displayName = name;
    if (name.toLowerCase() == 'Generic'.toLowerCase()) {
      displayedColumns = this.displayedColumnsForGeneric;
      tableData = [...(this.fieldData['key'] || []), ...(this.fieldData[name] || [])];
    } else if (name.toLowerCase() == 'Initiative'.toLowerCase()) {
      displayedColumns = this.displayedColumnsForInitiative;
      tableData = [...(this.fieldData[name] || [])];
    } else if(name.toLowerCase() == 'Calc_initiative'.toLowerCase()) {
      displayedColumns = this.displayedColumnsForCalcInitiative;
      tableData = [...(this.fieldData[name] || [])];
    }
    tableData.sort((a, b) => a.colorder - b.colorder);
    tableData.map((val) => {
      if(typeof val['allowed_values'] === 'string'){
        val['allowed_values'] = val['allowed_values'] ?  val['allowed_values'].split(',').map(s => s.trim()) : [];
      }
      val['allowed_values'] = val['allowed_values'].sort();
      if(typeof val['Edit_Roles'] === 'string'){
        val['Edit_Roles'] = val['Edit_Roles'] ? val['Edit_Roles'].split(',').map(s => s.trim()) : [];
      }
      val['Edit_Roles'] = val['Edit_Roles'].sort();
    });
    const obj = {
      name: name,
      displayName: displayName,
      displayedColumns: displayedColumns,
      tableData: tableData,
      isOpen: false,
      isUpdated: false
    };
    return obj;
  }

  addReorderKey(name, flag) {
    if (this.fieldData[name] && this.fieldData[name].length > 0) {
      this.fieldData[name].forEach(element => {
        element.isReorder = flag;
        element['currentOrder'] = element.colorder;
      });
    }
  }

  enableNewField() {
    this.modalEnableField.show();
    this.clearFormFields = false;
  }

  closemodal() {
    this.clearFormFields = true;
  }

  submitEnableField(payloadData) {
    this.showLoader = true;
    this.modalEnableField.hide();
    this.maintenanceService.enabledFields(payloadData).subscribe(
      res => {
        if (res) {
          this.toastrService.success(res.msg, '', { positionClass: 'toast-top-center', timeOut: 2000 });
          this.getFieldData(payloadData.Field_Type, res.msg);
          this.showLoader = false;
        }
      },
      () => { // Removed unused 'error' parameter
        this.showLoader = false;
        this.toastrService.error('Something went wrong, Please try again later.', '', {
          positionClass: 'toast-top-center',
          timeOut: 1000
        });
      }
    );
  }

  getFieldData(type, message) {
    if (type == 'key') {
      type = 'Generic';
    }
    if (type == 'Generic') {
      this.reorderRowsForGeneric = [];
    } else if (type == 'Initiative') {
      this.reorderRowsForInitiative = [];
    } else if (type == 'Calc_initiative') {
      this.reorderRowsForCalcInitiative = [];
    }
    const obj = {
      message: message,
      type: type
    };
    this.updatedType = type;
    this.refreshData.emit(obj);
  }
  onApply(type) {
    let payload: any;
    if (type == 'Generic') {
      payload = this.reorderRowsForGeneric;
    } else if (type == 'Initiative') {
      payload = this.reorderRowsForInitiative;
    } else if (type == 'Calc_initiative') {
      payload = this.reorderRowsForCalcInitiative;
    }
    payload = payload.map(val => {
      return {
        column_id: val.column_id,
        currentIndex: val.currentOrder
      };
    });
    this.showLoader = true;
    this.maintenanceService.updateColorderForInitiatives(payload, this.selectedInitiative.initiative_ID).subscribe(
      (res: any) => {
        if (res.message) {
          this.toastrService.success('Records have been updated successfully', '', {
            timeOut: 2000,
            positionClass: 'toast-top-center'
          });
          this.getFieldData(type, res.message);
          this.showLoader = false;
        }
      },
      () => { // Removed unused 'err' parameter
        this.showLoader = false;
        this.toastrService.error('Something went wrong, Please try again later.', '', {
          timeOut: 2000,
          positionClass: 'toast-top-center'
        });
      }
    );
  }

  exportToExcel() {
    const exportDataForGeneric = [];
    const exportDataForCalcInitiative = [];
    const exportDataForInitiative = [];

    this.fieldData.key?.forEach(element => {
      const fieldObj = {};
      fieldObj['Column ID'] = element.column_id;
      fieldObj['Column Name'] = element.column_name;
      fieldObj['Description'] = element.Description;
      fieldObj['Visible'] = element.Visible;
      fieldObj['Bulk Required'] = element.Bulk_required;
      exportDataForGeneric.push(fieldObj);
    });
    this.fieldData.Generic?.forEach(element => {
      const fieldObj = {};
      fieldObj['Column ID'] = element.column_id;
      fieldObj['Column Name'] = element.column_name;
      fieldObj['Description'] = element.Description;
      fieldObj['Visible'] = element.Visible;
      fieldObj['Bulk Required'] = element.Bulk_required;
      exportDataForGeneric.push(fieldObj);
    });
    this.fieldData.Calc_initiative?.forEach(element => {
      const fieldObj = {};
      fieldObj['Column ID'] = element.column_id;
      fieldObj['Column Name'] = element.column_name;
      fieldObj['Description'] = element.Description;
      fieldObj['Visible'] = element.Visible;
      fieldObj['Bulk Required'] = element.Bulk_required;
      exportDataForCalcInitiative.push(fieldObj);
    });
    this.fieldData.Initiative?.forEach(element => {
      const obj = {};
      obj['Column ID'] = element.column_id;
      obj['Column Name'] = element.column_name;
      obj['Description'] = element.Description;
      obj['Allowed Values'] = element.allowed_values.join(', ');
      obj['Visible'] = element.Visible;
      obj['Editable'] = element.Editable;
      obj['Bulk Required'] = element.Bulk_required;
      obj['Category'] = element.category;
      obj['Sub Category'] = element.SubCategory ?? element.sub_category;
      obj['Category Default State'] = element.category_default_state;
      obj['Data Type'] = element.data_type;
      obj['Input Type'] = element.input_type;
      obj['length'] = element.length;
      exportDataForInitiative.push(obj);
    });
    this.exportService.exportToExcel(
      'Field Management',
      [exportDataForGeneric, exportDataForCalcInitiative, exportDataForInitiative],
      ['Generic', 'Calc_initiative', 'Initiative']
    );
  }

  getReorderRows(ev, type) {
    if (type == 'Generic') {
      this.reorderRowsForGeneric = ev;
    } else if (type == 'Initiative') {
      this.reorderRowsForInitiative = ev;
    } else if (type == 'Calc_initiative') {
      this.reorderRowsForCalcInitiative = ev;
    }
  }

  updateFieldData(ev) {
    this.getFieldData(ev.type, ev.message);
  }

  getRoleDrpdwnLst() {
    const payload = {
      initiativeID: this.initiativeId
    };
    this.maintenanceService.getAllInitiativeRoles(payload).subscribe(response => {
      if (response && response.roles?.length > 0) {
        this.editRolesOptions = response.roles.sort();
      }
    });
  }

  //Function to get categories data including default state
  getCategories(val) {
    let categories:any = [];
    if(val && val.tableData && val.tableData.length > 0) {
      categories = val.tableData.reduce((acc, curr) => {
        if (curr.category && !acc.some(cat => cat.categoryName === curr.category)) {
          acc.push({categoryName : curr.category, defaultState : curr.category_default_state});
        }
        return acc;
      }, []);
    }
    return categories;
  }
}
